<template>

  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'UserList' }">User</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
      ref="user_access"
      :model="user_access"
      :rules="rules.user_access"
      :label-position="label_position">

      <el-form-item label="Name" prop="name">
        <el-input v-model="user_access.name"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="addUserAccess('user_access')">Add</el-button>
      </el-form-item>

    </el-form>

    <pre v-if="config.debug">{{$data}}</pre>

  </div>

</template>

<style>

</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return {
        page_alias: 'Add User Access',
        page_slug: 'add-user-access',

        config: Config.config,

        label_position: 'top',
        loading: false,

        user_access: {
          name: '',
          display_name: '',
        },

        rules: {
          user_access: {
            name: [
              {required: true, message: 'Please Enter Name', trigger: 'blur'}
            ]
          }
        }
      };
    },

    methods: {
      addUserAccess: function(formName) {
        console.log('Add User Access Function');
        const me = this;

        me.$refs[formName].validate((valid) => {
          if(valid) {
            me.$http.post(me.config.api + 'access', me.user_access).then(
              response => {
              console.log('Add User Access Function - Success Posting Data');

              me.$notify({
                title: 'Success',
                message: 'The User Access Was Added',
                type: 'success'
              });

              me.$router.push({name: 'UserAccessList'});
            }, response => {
              console.log('Add User Access Function - Error Posting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      } //LAST METHOD
    }//END METHODS
  }
</script>


// WEBPACK FOOTER //
// src/pages/user-access/UserAccessAdd.vue